var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"factfield-app"}},[(_vm.dev)?_c('Login',{staticClass:"debug-login"}):_vm._e(),_c('router-view'),_c('portal-target',{attrs:{"name":"a11y-vue-dialogs-main","multiple":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }